export const appHostname = (subdomain = 'app') => {
  return `${subdomain}.${__HOSTNAME__}`;
};
